import React, { Component } from "react";
import { formatCurrency } from "../../../utils/constants";
import { AppContext } from "../../../utils/context";
import classnames from 'classnames';

class SplitThePot extends Component {
  render() {
    const { title, date, jackpot, prize, draws } = this.props.event;
    const { settings } = this.props;
    const { config } = this.context;

    const heroDrawTitleClasses = classnames('font-semibold', 'mb-2',  settings.font_size_raffle_title ); //text-3xl
    const heroProgressiveJackpotClasses = classnames('font-bold', settings.font_size_progressive_jackpot_title ); //text-5xl
    const heroWeeklyPrizeClasses = classnames('font-bold ', settings.font_size_weekly_prize_title ); //text-5xl
    const heroWeeklyPrizeOnlyClasses = classnames('font-bold ', 'mt-2', 'text-primary', settings.font_size_weekly_prize_title ); //text-5xl
    const heroDrawDateLabelClasses = classnames('font-light', settings.font_size_draw_date_label ); //text-xs
    const heroDrawDateClasses = classnames('font-light', settings.font_size_draw_date_value ); //text-base
    const heroJackpotBottomTextClasses = classnames('font-light', 'mt-2', 'mb-8', settings.font_size_jackpot_bottom_text ); //text-xl
    const heroPrizeLabelClasses = classnames('font-light', 'my-2', settings.font_size_prize_label ); //text-xl
    const heroPrizeOnlyLabelClasses = classnames('font-light', 'mt-6', settings.font_size_prize_label ); //text-xl

    return (
      <div>
        <div className={heroDrawTitleClasses}>{title}</div>
        <div className={heroDrawDateLabelClasses}>DRAW DATE:</div>
        <div className={heroDrawDateClasses}>{date}</div>
        {settings.hero_display_jackpot && (
          <div className="jackpot">
            <div className={heroProgressiveJackpotClasses}>
              {formatCurrency(jackpot, config.language)}
            </div>
            {settings.hero_prize_text && <div className={heroJackpotBottomTextClasses}>
              {settings.hero_prize_text}
            </div>}
            {settings.hero_display_prize && (
              <div className={heroPrizeLabelClasses}>
                EST. PRIZE:{" "}
                <span className={heroWeeklyPrizeClasses}>
                  {formatCurrency(prize, config.language)}
                </span>
              </div>
            )}
          </div>
        )}
        {!settings.hero_display_jackpot && settings.hero_display_prize && (
          <div className="jackpot">
            <div className={heroPrizeOnlyLabelClasses}>
              EST. PRIZE
            </div>
            <div className={heroWeeklyPrizeOnlyClasses}>
              {formatCurrency(prize, config.language)}
            </div>
          </div>
        )}
        {draws[0].number !== null && (
          <div className="block py-3 px-6">
            <div className={draws[0].winning_card ? "text-primary" : ""}>
              <div className="text-base mb-2">WINNING TICKET:</div>
              <div className="font-bold text-2xl mb-2">#{draws[0].number}</div>
              <span
                to={`/winners`}
                className="inline-block font-bold rounded"
              >
                See all winners {">"}
                </span>
            </div>
          </div>
          )}
      </div>
    );
  }
}

SplitThePot.contextType = AppContext;
export default SplitThePot;
